var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"e-offcanvas__nav"},[(_vm.title)?_c('h4',{staticClass:"e-offcanvas__nav-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('ul',[_vm._t("default")],2),_vm._t("append")],2)}
var staticRenderFns = []

export { render, staticRenderFns }